import axios from "./axiosInstance";

// Public: HAJEX Bolt's Terms of Service and Privacy Policy (no login needed).
export const fetchLegalDocument = async (type, language, version) => {
  let response = { data: null, error: null };
  try {
    const path = version
      ? `legal-documents/${type}/${language}/${encodeURIComponent(version)}`
      : `legal-documents/${type}/${language}`;
    const res = await axios.get(path);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
